import round from 'lodash/round';

export const valueOrZero = value => value || 0;

// Rounds half away from zero like Ruby's BigDecimal#round(2); toPrecision(15) first drops float noise
// so an exact half-cent (1983.5549999999996) rounds up instead of down.
export function roundToCents(value) {
  const cents = round(Number(Math.abs(value).toPrecision(15)), 2);
  return value < 0 ? -cents : cents;
}
